import { render, staticRenderFns } from "./overdueCourses.vue?vue&type=template&id=38f9577f&scoped=true&"
import script from "./overdueCourses.vue?vue&type=script&lang=js&"
export * from "./overdueCourses.vue?vue&type=script&lang=js&"
import style0 from "./overdueCourses.vue?vue&type=style&index=0&id=38f9577f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9577f",
  null
  
)

export default component.exports